import { RouteConfig } from 'vue-router';

import { PublicSettings } from '@/enums/publicSettings.enum';
import { TableName } from '@/enums/tableName';
import store from '@/store/store';
import { tryParseInt } from '@/utils/number';
import { prepareQuery } from '@/utils/prepareQuery';
import PaymentPacks from '@/views/mainRoute/procedure/payments/PaymentPacks.vue';

export const procedurePaymentPacksRoute: RouteConfig = {
  path: '',
  name: 'procedurePaymentPacks',
  component: PaymentPacks,
  beforeEnter: (to, from, next) => {
    const entityType = TableName.procedure;
    store
      .dispatch('setting/findPublic', {
        code: PublicSettings.CHILD_PROCEDURE_ID,
        entityType,
        entityId: to.params.procedureId.toString()
      })
      .then(setting => {
        const procedureId = tryParseInt(setting?.value, to.params.procedureId.toString());
        return Promise.all([
          store.dispatch('paymentPack/list', {
            ...prepareQuery(to),
            procedureId,
            structureIds: store.state.auth.nodes.map((node: any) => node.id)
          })
        ]);
      })
      .then(() => next());
  }
};
